export default "__VITE_ASSET__eZzx_rj1__"